<template>
    <div class="cp-language-selector -pointer" :class="{'is-black' : color && color.isblack, 'is-fixed': color && color.isfixed, 'is-open': color && color.isopen}">
        <div class="current" v-if="header">{{ currentLang }}</div>
        <ul class="header" v-if="header">
            <li v-for="(lang, index) in allCountry" :key="index">
                <div @click="changeLang(lang.locale)">
                    <span class="locale">{{ lang.locale }}</span>
                    <span
                        class="name"
                        :class="{ '-active': lang.locale === currentLang }"
                        >{{ lang.label }}</span
                    >
                </div>
            </li>
        </ul>
        <ul class="not-header" :class="{ '-open': activeMenu }" v-if="!header">
            <li
                v-for="(lang, index) in allCountry"
                :key="index"
                @click="openMenu"
                :class="{ 'language-selected': lang.lang == currentLang }"
            >
                <span @click="changeLang(lang.lang)">{{ lang.locale }}</span>
            </li>
        </ul>
        <i
            class="ox-menu-arrow"
            :class="{ '-is-white': !header, transform: activeMenu }"
        ></i>
    </div>
</template>

<script>
export default {
    props: {
        header: {
            type: Boolean,
            default: true,
        },
        color: {
            type: [Array, Object],
            required: false,
            default: null
        }
    },
    data() {
        return {
            activeMenu: false,
        };
    },

    computed: {
        allCountry() {
            return this.$store.state.languages.list;
        },
        currentLang() {
            return this.$store.state.languages.current;
        },
    },
    methods: {
        openMenu() {
            this.activeMenu = !this.activeMenu;
        },
        changeLang(value) {
            const { current } = this.$store.state.languages;

            this.$store.commit("languages/SET_CURRENT", value);

            if (current !== value) window.location.href = `/${value}`;
        },
    },
};
</script>
